import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageBubble } from '@/shared/ui';
import type { ChatMessage } from '@/widgets/right-side-menu/lib/chat-types';
import { AssistantMessage } from './AssistantMessage';
import { ChatInput } from './ChatInput';
import { LoadingMessage } from './LoadingMessage';

type Props = {
  messages: ChatMessage[];
  isLoading: boolean;
  onSend: (message: string) => void;
};

/** チャットスレッド表示。メッセージ一覧（ユーザー/AI応答）と入力欄を縦に配置する */
export const ChatThreadView: FC<Props> = ({ messages, isLoading, onSend }) => {
  const { t } = useTranslation();
  // スムーズスクロールは目への負荷が大きいので auto（瞬時）でジャンプする
  const scrollToBottom = (node: HTMLDivElement | null) => {
    node?.scrollIntoView({ behavior: 'auto' });
  };

  return (
    <div className="flex h-full flex-col">
      <div className="flex-1 overflow-y-auto pb-4">
        <div className="flex flex-col gap-6 pt-4">
          {messages.map((message) =>
            message.role === 'user' ? (
              <div key={message.id} className="pl-12">
                <MessageBubble message={message.content} position="right" />
              </div>
            ) : (
              <AssistantMessage
                key={message.id}
                content={message.content}
                projectPrompt={message.projectPrompt}
              />
            ),
          )}
          {isLoading && <LoadingMessage />}
          <div key={messages.length} ref={scrollToBottom} />
        </div>
      </div>

      <div className="shrink-0 pb-4">
        <ChatInput
          onSend={onSend}
          waiting={isLoading}
          placeholder={t('ai.chat.input-placeholder-thread')}
        />
      </div>
    </div>
  );
};
